<template>
  <div class="calendar">
    <!-- Month Navigation -->
    <div class="month">
      <a href="#" class="nav" @click.prevent="changeMonth(-1)">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="black" class="bi bi-arrow-left-short" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"/>
        </svg>
      </a>
      <div>{{ monthName }} <span class="year">{{ year }}</span></div>
      <a href="#" class="nav" @click.prevent="changeMonth(1)">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="black" class="bi bi-arrow-right-short" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8"/>
        </svg>
      </a>
    </div>

    <!-- Days of the Week -->
    <div class="days">
      <span>Lun</span>
      <span>Mar</span>
      <span>Mer</span>
      <span>Jeu</span>
      <span>Ven</span>
      <span>Sam</span>
      <span>Dim</span>
    </div>

    <!-- Calendar Dates -->
    <div class="dates">
      <button :style="{ 'grid-column': (index === 0) ? startOfMonth : 'initial' }" :class="{'has-freetime': (format_date(year,month,day) in get_free_days), 'is-selected': day == selected_day}" 
              v-for="(day, index) in daysInMonth" :key="day" @click="select_date(year,month,day)">
        <time>{{ day }}</time>
      </button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

// console.log(moment(), moment().format('MM'), moment("2025" + "-" + "06" + "-01").format('e'))
function gridColumn(year, month) {
      let x = 0
      x = parseInt(moment(year + "-" + month + "-01").format('e'))
      return x === 0 ? 7 : x
    }
export default {
  name: 'DatePicker',
  props: {
    free_days: {}
  },
  emits: ['selected','monthChanged'],
  data() {
    
    return {
      month: parseInt(moment().format('MM')), // January
      year:  parseInt(moment().format('YYYY')),
      startOfMonth: gridColumn(this.year, this.month),
      selected_day: null,
      mounted: false
    };
  },
  computed: {
    get_free_days(){
      console.log("datepicker get_free_days",Object.keys(this.free_days));
      return this.free_days;
    },
    // Compute the month name (January, February, etc.)
    monthName() {
      const months = [
        'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
        'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
      ];
      return months[this.month - 1];
    },
    // Calculate the number of days in the current month
    daysInMonth() {
      // Adjust for leap year in February
      const daysInMonthMap = {
        0: 0,
        1: 31, // January
        2: (this.isLeapYear() && this.year % 4 === 0) ? 29 : 28, // February
        3: 31, // March
        4: 30, // April
        5: 31, // May
        6: 30, // June
        7: 31, // July
        8: 31, // August
        9: 30, // September
        10: 31, // October
        11: 30, // November
        12: 31 // December
      };

      // Get the number of days in the current month
      const days = daysInMonthMap[this.month];

      // Create an array of days for the current month
      return Array.from({ length: days }, (_, index) => index + 1);
    }
  },
  methods: {
    // Change month by clicking left or right arrow
    
    changeMonth(direction) {
      this.month += direction;
      // Handle year change when going from December to January or vice versa
      if (this.month > 12) {
        this.month = 1;
        this.year++;
      } else if (this.month < 1) {
        this.month = 12;
        this.year--;
      }
      this.startOfMonth = gridColumn(this.year, this.month)
      this.$emit('monthChanged',{year:this.year ,month:this.month});
    },
    // Check if the current year is a leap year
    isLeapYear() {
      return (this.year % 4 === 0 && this.year % 100 !== 0) || (this.year % 400 === 0);
    },
    format_date(year,month,day){
      return year+'-'+(month.toLocaleString('fr-FR',{minimumIntegerDigits:2,useGrouping:false}))+'-'+(day.toLocaleString('fr-FR',{minimumIntegerDigits:2,useGrouping:false}));
    },
    select_date(year,month,day){
      this.selected_day = day;
      this.$emit('selected',this.format_date(year,month,day));
    },
    set_month_year(date) {
      const newDate = date.split("-");

      this.year = parseInt(newDate[0])
      this.month = parseInt(newDate[1])
      this.mounted = true
    }
  },
  created() {
    this.changeMonth(0)
  },

  mounted() {
    console.log("datepicker mounted freedays",Object.keys(this.free_days));
  },

  updated(){
    const first_date = Object.keys(this.free_days)[0]
    // console.log('datepicker updated rere', Object.keys(this.free_days));
    if (this.mounted === false)
      this.set_month_year(first_date)
  }

};
</script>

<style scoped>
    .day-btn {
        width: 48px;
        height: 48px;
    }
    
    .calendar {
        height: 488px;
        /* display: inline-grid; */
        justify-content: center;
        align-items: center;
        background: #fff;
        padding: 20px;
        border-radius: 5px;
    }

    .calendar .month {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 20px;
        font-weight: 300;
    }

    .calendar .month .year {
        font-weight: 600;
        margin-left: 10px;
    }

    .calendar .month .nav {
        display: flex;
        justify-content: center;
        align-items: center;
        text-decoration: none;
        color: #0a3d62;
        width: 40px;
        height: 40px;
        border-radius: 40px;
        transition-duration: 0.2s;
        position: relative;
    }

    .calendar .month .nav:hover {
        background: #eee;
    }

    .calendar .days {
        display: grid;
        justify-content: center;
        align-items: center;
        grid-template-columns: repeat(7, 1fr);
        color: #999;
        padding: 0px 10px;
        font-weight: 600;
        margin-top: 12px;
        margin-bottom: 12px;
        /* gap: 58px; */
    }

    .calendar .days span {
        width: 50px;
        justify-self: center;
        align-self: center;
        text-align: center;
    }

    .calendar .dates {
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        /* gap: 23px 41px; */
    }

    .calendar .dates button {
        cursor: pointer;
        outline: 0;
        border: 0;
        background: transparent;
        font-size: 16px;
        justify-self: center;
        align-self: center;
        width: 30px;
        height: 30px;
        border-radius: 50px;
        margin: 2px;
        transition-duration: 0.2s;
    }

    /* color: #fff; */
    .has-freetime{
      color: var(--primary-color);
      background-color: rgba(39, 28, 73, 0.07) !important;
    }

    .is-selected{
      color: #fff;
      background-color: var(--primary-color) !important;
    }

    .calendar .dates button.today {
        box-shadow: inset 0px 0px 0px 2px #0a3d62;
    }

    .calendar .dates button:first-child {
        grid-column: 3;
    }

    .calendar .dates button:hover {
        background: #eee;
    }

    /* var(--primary-color) */
    /* .calendar .dates button:focus {
        background: var(--primary-color) !important;
        color: #fff;
        font-weight: 600;
    } */

    @media (min-width: 1400px) {
      .calendar .days{
          gap: 18px;
      }

      .calendar .dates{
          gap: 30px 11px;
      }

      .calendar .dates button{
          width: 50px;
          height: 50px;
      }
    }

    @media (min-width: 1300px) and (max-width: 1400px) {
      .calendar .dates button {
        width: 40px;
        height: 40px;
      }
    }

    @media (max-width: 1400px) {
      .calendar .dates{
        gap: 25px 0px;
      }
    }

    @media (max-width: 1199px) {
      .calendar{
        padding-left: 0px;
        padding-right: 0px;
      }
      .calendar .days{
          /* gap: 18px; */
      }

      .calendar .dates{
          /* gap: 23px 41px; */
      }

      .calendar .dates button{
          /* width: 50px;
          height: 50px; */
      }
    }
</style>